<template>
  <v-btn
    :block="block"
    :size="size"
    :rounded="typeof pill == 'string' ? 'xl' : 'md'"
    v-if="typeof icon == 'boolean'"
    :variant="variant"
    :flat="flat"
    :ripple="ripple"
    :readonly="disabled"
    :density="variant == 'custom-link' ? 'compact' : 'default'"
    :class="{ 'custom-btn--auto-width': autoWidth }"
  >
    <slot />
  </v-btn>
  <v-btn
    density="compact"
    :block="block"
    v-else
    :variant="variant"
    :flat="flat"
    icon
    size="x-large"
    :ripple="ripple"
    :readonly="disabled"
    :class="{ 'custom-btn--auto-width': autoWidth }"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: "CustomButton",
  props: {
    block: { required: false, default: () => false },
    pill: {
      required: false,
      default: () => false
    },
    icon: {
      required: false,
      default: false
    },
    variant: {
      required: false,
      default: "flat"
    },
    flat: {
      required: false,
      default: false
    },
    ripple: {
      required: false,
      default: false
    },
    size: {
      required: false,
      default: "default"
    },
    disabled: {
      required: false,
      type: Boolean
    },
    autoWidth: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  created() {}
};
</script>

<style scoped>
.custom-btn--auto-width {
  min-width: 0 !important;
  width: auto !important;
  padding-inline: 12px;
  max-width: fit-content;
}
</style>
